import Heading from 'LuxKit/Typography/Heading'

interface Props {
  intro: string
  highlight?: string
}

function ImageTitle({ intro, highlight }: Props) {
  return <>
    <Heading variant="heading2" colour="dark-contrast" align="center">
      {intro}
    </Heading>
    {highlight && <Heading variant="heading2alt" colour="dark-contrast" align="center">
      {highlight}
    </Heading>}
  </>
}

export default ImageTitle
